import { React, useEffect, useState } from "react";
import img_rana_hoja from "../../assets/images/img_rana_hoja.png";
import ico_rana from "../../assets/icons/ico_rana.svg";
import ico_mono from "../../assets/icons/ico_mono.svg";
import ico_hoja from "../../assets/icons/ico_hoja.svg";
import ico_libelula from "../../assets/icons/ico_libelula.svg";
import ico_lombriz from "../../assets/icons/ico_lombriz.svg";
import ico_pajaro from "../../assets/icons/ico_pajaro.svg";
import ico_escarabajo from "../../assets/icons/ico_escarabajo.svg";
import img_leopardo_groups from "../../assets/images/img_leopardo_groups.png";
import ico_murcielago from "../../assets/icons/ico_murcielago.svg";
import img_zorro_volador_groups from "../../assets/images/img_zorro_volador_groups.png";
import img_escarabajo from "../../assets/images/img_escarabajo.png";
import img_libelula_tools from "../../assets/images/img_libelula_tools.png";
import img_grillo from "../../assets/images/img_grillo.png";
import img_banana_tree_groups from "../../assets/images/img_banana_tree_groups.png";
import img_pajaro_groups from "../../assets/images/img_pajaro_groups.png";
import GoToPage from "../../components/goToPage";
import img_fondo_grupos from "../../assets/images/img_fondo_grupos.png";
import GroupsDualTile from "../../components/groupsDualTile";
import GroupsLayeredTile from "../../components/groupsLayeredTile";
import GroupsMobileTile from "../../components/groupsMobileTile";
import SpeciesInfo from "../../components/speciesInfo";

//900 px
const GroupsScreen = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
      console.log(width);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  return (
    <div className=" bg-green-900  overflow-hidden ">
      <div className="w-full mx-auto text-white relative">
        <img
          loading="lazy"
          src={img_fondo_grupos}
          className="w-full h-full object-cover absolute  scale-150"
        ></img>
        <div className="grid lg:pt-[176px] lg:px-52 2xl:grid-cols-5 lg:grid-cols-1  md:grid-cols-1 sm:grid-cols-1 pb-20 min-w-[10rem] lg:gap-0  relative">
          <div className="lg:col-span-3 md:col-span-1 sm:col-span-1 col-span-1 text-left lg:mr-10 mr-10 lg:ml-0 md:ml-10 sm:ml-10 ml-10 sm:bottom-0  w-full h-full relative 2xl:mt-0 xl:mt-[25rem] lg:mt-[25rem] md:mt-[25rem] sm:mt-[30rem] mt-[30rem] ">
            <div className="absolute bottom-0 pb-32 pr-20">
              <div className=" mt-20 ">
                <GoToPage
                  page="/"
                  side="left"
                  name="Atrás"
                  fontSizeXL="xl:text-xl"
                  fontSizeL="lg:text-lg"
                  fontSizeM="md:text-lg"
                  fontSizeS="sm:text-base"
                  fontSize="text-base"
                  textType="font-bold"
                  textColor="text-white"
                  borderType="border-b-2"
                  borderColor="border-white"
                  iconSize="h-5"
                  iconColor="invert"
                  iconMargin="mr-5"
                ></GoToPage>
              </div>

              <div className="flex lg:justify-start md:justify-start sm:justify-center justify-center">
                <img
                  loading="lazy"
                  src={ico_hoja}
                  className="mb-10 mt-14 "
                ></img>
              </div>
              <h1 className="xl:text-7xl lg:text-5xl md:text-4xl sm:text-4xl text-4xl lg:text-left md:text-left sm:text-center text-center font-bold">
                Grupos <br /> para monitorear
              </h1>
              <p className=" text-lg mt-10">
                Con toda la increíble diversidad de formas de vida existente, un
                primer paso en el monitoreo es decidir con cuál parte de dicha
                diversidad se trabajara. Lo más lógico es generar un inventario
                con los distintos grupos de especies que habitan en el área de
                operación de la empresa.
              </p>
              <p className=" text-lg mt-5">
                Este inventario debe realizarse a nivel de grupo o grupos
                taxonómicos y sirve como línea de referencia o base.
              </p>
            </div>
          </div>

          <div className="grid grid-rows-2 grid-cols-1 lg:col-span-2 mt-10">
            <div className="lg:col-span-3"></div>
            {width > 900 ? (
              <div className="bg-[#009269] lg:col-span-3 2xl:mb-0 xl:mb-10 lg:mb-10 md:mb-10 sm:mb-10 mb-10 lg:mx-0 md:mx-10 sm:mx-10 mx-10">
                <div className="overflow-hidden ">
                  <GroupsLayeredTile
                    ico={ico_rana}
                    title="Herpetofauna"
                    subTile=""
                    linkPage="/grupos/herpetofauna"
                    linkSide="right"
                    linkName="Entrar"
                    linkFontsize="text-xl"
                    linkTextColor="text-white"
                    linkBorderType="border-b-2"
                    linkBorderColor="border-white"
                    linkIconSize="h-4"
                    linkIconColor="invert"
                    linkIconMargin="ml-5"
                  ></GroupsLayeredTile>
                  <div className="relative mt-60">
                    <img
                      loading="lazy"
                      src={img_rana_hoja}
                      className="absolute w-full right-0 bottom-0 "
                    ></img>
                  </div>
                </div>
              </div>
            ) : (
              <div className="bg-[#009269] lg:col-span-3 lg:mb-0 md:mb-10 sm:mb-10 mb-10 lg:mx-0 md:mx-10 sm:mx-10 mx-10">
                <div className=" overflow-hidden">
                  <GroupsMobileTile
                    ico={ico_rana}
                    title={
                      <h1 className="text-3xl font-bold  mt-5">Herpetofauna</h1>
                    }
                    subTile=""
                    linkPage="/grupos/herpetofauna"
                    linkSide="right"
                    linkName="Entrar"
                    linkFontsize="text-xl"
                    linkTextColor="text-white"
                    linkBorderType="border-b-2"
                    linkBorderColor="border-white"
                    linkIconSize="h-4"
                    linkIconColor="invert"
                    linkIconMargin="ml-5"
                  ></GroupsMobileTile>
                  <div className="relative w-full mt-10">
                    <img
                      loading="lazy"
                      src={img_rana_hoja}
                      className="absolute w-full right-0 bottom-0 "
                    ></img>
                  </div>
                </div>
              </div>
            )}
          </div>
          {width > 900 ? (
            <div className=" bg-[#048CC6] lg:col-span-3 2xl:mb-0 xl:mb-10 lg:mb-10 md:mb-10 sm:mb-10 mb-10 lg:mx-0 md:mx-10 sm:mx-10 mx-10">
              <div className="overflow-hidden h-full ">
                <GroupsDualTile
                  ico={ico_mono}
                  title={
                    <h1 className="text-5xl font-bold pl-10 mt-[2rem]">
                      Mamíferos
                    </h1>
                  }
                  subTile=""
                  linkPage="/grupos/mamiferos"
                  linkSide="right"
                  linkName="Entrar"
                  linkFontsize="text-xl"
                  linkTextColor="text-white"
                  linkBorderType="border-b-2"
                  linkBorderColor="border-white"
                  linkIconSize="h-4"
                  linkIconColor="invert"
                  linkIconMargin="ml-5"
                ></GroupsDualTile>
                <div className="relative  mt-20">
                  <img
                    loading="lazy"
                    src={img_leopardo_groups}
                    className="absolute xl:w-[37rem] lg:w-[35rem] md:w-[30rem] sm:w-[25rem] w-[30rem] bottom-20 right-0"
                  ></img>
                </div>
              </div>
            </div>
          ) : (
            <div className=" bg-[#048CC6] lg:col-span-3 lg:mb-0 md:mb-10 sm:mb-10 mb-10 lg:mx-0 md:mx-10 sm:mx-10 mx-10">
              <div className=" overflow-hidden">
                <GroupsMobileTile
                  ico={ico_mono}
                  title={
                    <h1 className="text-3xl font-bold  mt-5">Mamíferos</h1>
                  }
                  subTile=""
                  linkPage="/grupos/mamiferos"
                  linkSide="right"
                  linkName="Entrar"
                  linkFontsize="text-xl"
                  linkTextColor="text-white"
                  linkBorderType="border-b-2"
                  linkBorderColor="border-white"
                  linkIconSize="h-4"
                  linkIconColor="invert"
                  linkIconMargin="ml-5"
                ></GroupsMobileTile>
                <div className="relative w-full">
                  <img
                    loading="lazy"
                    src={img_leopardo_groups}
                    className="absolute w-[20rem] bottom-0 -right-[8rem]"
                  ></img>
                </div>
              </div>
            </div>
          )}

          {width > 900 ? (
            <div className="bg-[#F2B229] lg:col-span-2 2xl:mb-0 xl:mb-10 lg:mb-10 md:mb-10 sm:mb-10 mb-10 lg:mx-0 md:mx-10 sm:mx-10 mx-10">
              <div className="h-full">
                <GroupsDualTile
                  ico={ico_murcielago}
                  title={
                    <h1 className="text-5xl font-bold pl-10 mt-[2rem]">
                      Murciélagos
                    </h1>
                  }
                  subTile="overflow-hidden "
                  linkPage="/grupos/murcielagos"
                  linkSide="right"
                  linkName="Entrar"
                  linkFontsize="text-xl"
                  linkTextColor="text-white"
                  linkBorderType="border-b-2"
                  linkBorderColor="border-white"
                  linkIconSize="h-4"
                  linkIconColor="invert"
                  linkIconMargin="ml-5"
                ></GroupsDualTile>
                <div className="relative ">
                  <img
                    loading="lazy"
                    src={img_zorro_volador_groups}
                    className="absolute 2xl:w-[14.5rem] xl:w-[11.7rem] lg:w-[11.7rem] md:w-[11.7rem] sm:w-[5rem] w-[5rem] bottom-5 right-0"
                  ></img>
                </div>
              </div>
            </div>
          ) : (
            <div className="bg-[#F2B229] lg:col-span-2 lg:mb-0 md:mb-10 sm:mb-10 mb-10 lg:mx-0 md:mx-10 sm:mx-10 mx-10">
              <div className=" overflow-hidden">
                <GroupsMobileTile
                  ico={ico_murcielago}
                  title={
                    <h1 className="text-3xl font-bold  mt-5">Murciélagos</h1>
                  }
                  subTile=""
                  linkPage="/grupos/murcielagos"
                  linkSide="right"
                  linkName="Entrar"
                  linkFontsize="text-xl"
                  linkTextColor="text-white"
                  linkBorderType="border-b-2"
                  linkBorderColor="border-white"
                  linkIconSize="h-4"
                  linkIconColor="invert"
                  linkIconMargin="ml-5"
                ></GroupsMobileTile>
                <div className="relative w-full">
                  <img
                    loading="lazy"
                    src={img_zorro_volador_groups}
                    className="absolute w-[9rem] bottom-0 mb-5 right-0"
                  ></img>
                </div>
              </div>
            </div>
          )}

          {width > 900 ? (
            <div className="bg-[#F2B229] lg:col-span-2 2xl:mb-0 xl:mb-10 lg:mb-10 md:mb-10 sm:mb-10 mb-10 lg:mx-0 md:mx-10 sm:mx-10 mx-10">
              <div className="overflow-hidden h-full ">
                <GroupsLayeredTile
                  ico={ico_escarabajo}
                  title="Escarabajos Estercoleros"
                  subTile=""
                  linkPage="/grupos/escarabajos-estercoleros"
                  linkSide="right"
                  linkName="Entrar"
                  linkFontsize="text-xl"
                  linkTextColor="text-white"
                  linkBorderType="border-b-2"
                  linkBorderColor="border-white"
                  linkIconSize="h-4"
                  linkIconColor="invert"
                  linkIconMargin="ml-5"
                ></GroupsLayeredTile>
                <div className="relative mt-[10rem]">
                  <img
                    loading="lazy"
                    src={img_escarabajo}
                    className="absolute w-[24rem] mt-[10rem] right-0 bottom-0 "
                  ></img>
                </div>
              </div>
            </div>
          ) : (
            <div className="bg-[#F2B229] lg:col-span-2 lg:mb-0 md:mb-10 sm:mb-10 mb-10 lg:mx-0 md:mx-10 sm:mx-10 mx-10">
              <div className=" overflow-hidden">
                <GroupsMobileTile
                  ico={ico_escarabajo}
                  title={
                    <h1 className="text-3xl font-bold  mt-5">
                      Escarabajos <br /> estercoleros
                    </h1>
                  }
                  subTile=""
                  linkPage="/grupos/escarabajos-estercoleros"
                  linkSide="right"
                  linkName="Entrar"
                  linkFontsize="text-xl"
                  linkTextColor="text-white"
                  linkBorderType="border-b-2"
                  linkBorderColor="border-white"
                  linkIconSize="h-4"
                  linkIconColor="invert"
                  linkIconMargin="ml-5"
                ></GroupsMobileTile>
                <div className="relative ">
                  <img
                    loading="lazy"
                    src={img_escarabajo}
                    className="absolute w-[18rem] mt-[10rem] right-0 bottom-0 "
                  ></img>
                </div>
              </div>
            </div>
          )}

          {width > 900 ? (
            <div className="bg-[#82AB40] lg:col-span-3 2xl:mb-0 xl:mb-10 lg:mb-10 md:mb-10 sm:mb-10 mb-10 lg:mx-0 md:mx-10 sm:mx-10 mx-10">
              <div className="overflow-hidden ">
                <GroupsLayeredTile
                  ico={ico_libelula}
                  title="Macro invertebrados acuáticos"
                  subTile=""
                  linkPage="/grupos/invertebrados-actuaticos"
                  linkSide="right"
                  linkName="Entrar"
                  linkFontsize="text-xl"
                  linkTextColor="text-white"
                  linkBorderType="border-b-2"
                  linkBorderColor="border-white"
                  linkIconSize="h-4"
                  linkIconColor="invert"
                  linkIconMargin="ml-5"
                ></GroupsLayeredTile>
                <div className="relative mt-[10rem] mr-[7rem]  bottom-0 ">
                  <img
                    loading="lazy"
                    src={img_libelula_tools}
                    className="absolute w-[25rem] right-0 bottom-0 "
                  ></img>
                </div>
              </div>
            </div>
          ) : (
            <div className="bg-[#82AB40] lg:col-span-3 lg:mb-0 md:mb-10 sm:mb-10 mb-10 lg:mx-0 md:mx-10 sm:mx-10 mx-10">
              <div className=" overflow-hidden">
                <GroupsMobileTile
                  ico={ico_libelula}
                  title={
                    <h1 className="text-3xl font-bold  mt-5">
                      Macro <br /> invertebrados <br /> acuáticos
                    </h1>
                  }
                  subTile=""
                  linkPage="/grupos/invertebrados-actuaticos"
                  linkSide="right"
                  linkName="Entrar"
                  linkFontsize="text-xl"
                  linkTextColor="text-white"
                  linkBorderType="border-b-2"
                  linkBorderColor="border-white"
                  linkIconSize="h-4"
                  linkIconColor="invert"
                  linkIconMargin="ml-5"
                ></GroupsMobileTile>
                <div className="relative    bottom-0 ">
                  <img
                    loading="lazy"
                    src={img_libelula_tools}
                    className="absolute w-[15rem] -right-6 bottom-0 "
                  ></img>
                </div>
              </div>
            </div>
          )}

          {width > 900 ? (
            <div className="bg-[#009269] lg:col-span-3 2xl:mb-0 xl:mb-10 lg:mb-10 md:mb-10 sm:mb-10 mb-10 lg:mx-0 md:mx-10 sm:mx-10 mx-10">
              <div className="overflow-hidden h-full ">
                <GroupsDualTile
                  ico={ico_lombriz}
                  title={
                    <h1 className="text-5xl font-bold  mt-5 pl-10">
                      Invertebrados <br /> de tierra
                    </h1>
                  }
                  subTile=""
                  linkPage="/grupos/invertebrados-tierra"
                  linkSide="right"
                  linkName="Entrar"
                  linkFontsize="text-xl"
                  linkTextColor="text-white"
                  linkBorderType="border-b-2"
                  linkBorderColor="border-white"
                  linkIconSize="h-4"
                  linkIconColor="invert"
                  linkIconMargin="ml-5"
                ></GroupsDualTile>
                <div className="relative w-full">
                  <img
                    loading="lazy"
                    src={img_grillo}
                    className="absolute w-[35rem] mr-20  right-0 bottom-0"
                  ></img>
                </div>
              </div>
            </div>
          ) : (
            <div className="bg-[#009269] lg:col-span-3 lg:mb-0 md:mb-10 sm:mb-10 mb-10 lg:mx-0 md:mx-10 sm:mx-10 mx-10">
              <div className="overflow-hidden">
                <GroupsMobileTile
                  ico={ico_lombriz}
                  title={
                    <h1 className="text-3xl font-bold  mt-5">
                      Invertebrados <br /> de tierra
                    </h1>
                  }
                  subTile=""
                  linkPage="/grupos/invertebrados-tierra"
                  linkSide="right"
                  linkName="Entrar"
                  linkFontsize="text-xl"
                  linkTextColor="text-white"
                  linkBorderType="border-b-2"
                  linkBorderColor="border-white"
                  linkIconSize="h-4"
                  linkIconColor="invert"
                  linkIconMargin="ml-5"
                ></GroupsMobileTile>
                <div className="relative w-full col-span-2 z-0 ">
                  <img
                    loading="lazy"
                    src={img_grillo}
                    className="absolute w-[22rem]  right-0 bottom-0  "
                  ></img>
                </div>
              </div>
            </div>
          )}

          {width > 900 ? (
            <div className="bg-[#F2B229] lg:col-span-2 2xl:mb-0 xl:mb-10 lg:mb-10 md:mb-10 sm:mb-10 mb-10 lg:mx-0 md:mx-10 sm:mx-10 mx-10">
              <div className="overflow-hidden h-full ">
                <GroupsDualTile
                  ico={ico_hoja}
                  title={
                    <h1 className="text-5xl font-bold pl-10 mt-[2rem] ">
                      Flora
                    </h1>
                  }
                  subTile=""
                  linkPage="/grupos/flora"
                  linkSide="right"
                  linkName="Entrar"
                  linkFontsize="text-xl"
                  linkTextColor="text-white"
                  linkBorderType="border-b-2"
                  linkBorderColor="border-white"
                  linkIconSize="h-4"
                  linkIconColor="invert"
                  linkIconMargin="ml-5"
                ></GroupsDualTile>
                <div className="relative w-full mt-[4.8rem]">
                  <img
                    loading="lazy"
                    src={img_banana_tree_groups}
                    className="absolute w-[27rem]  right-0 bottom-[4.8rem]"
                  ></img>
                </div>
              </div>
            </div>
          ) : (
            <div className="bg-[#F2B229] lg:col-span-2 lg:mb-0 md:mb-10 sm:mb-10 mb-10 lg:mx-0 md:mx-10 sm:mx-10 mx-10">
              <div className="overflow-hidden">
                <GroupsMobileTile
                  ico={ico_hoja}
                  title={<h1 className="text-3xl font-bold  mt-5">Flora</h1>}
                  subTile=""
                  linkPage="/grupos/flora"
                  linkSide="right"
                  linkName="Entrar"
                  linkFontsize="text-xl"
                  linkTextColor="text-white"
                  linkBorderType="border-b-2"
                  linkBorderColor="border-white"
                  linkIconSize="h-4"
                  linkIconColor="invert"
                  linkIconMargin="ml-5"
                ></GroupsMobileTile>
                <div className="relative w-full col-span-2">
                  <img
                    loading="lazy"
                    src={img_banana_tree_groups}
                    className="absolute w-[16.5rem]  right-0 bottom-0"
                  ></img>
                </div>
              </div>
            </div>
          )}

          {width > 900 ? (
            <div className="bg-[#82AB40] lg:col-span-2 2xl:mb-0 xl:mb-10 lg:mb-10 md:mb-10 sm:mb-10 mb-10 lg:mx-0 md:mx-10 sm:mx-10 mx-10">
              <div className="overflow-hidden h-full">
                <GroupsDualTile
                  ico={ico_pajaro}
                  title={
                    <h1 className="text-5xl font-bold pl-10 mt-[2rem]">
                      Avifauna
                    </h1>
                  }
                  subTile=""
                  linkPage="/grupos/avifauna"
                  linkSide="right"
                  linkName="Entrar"
                  linkFontsize="text-xl"
                  linkTextColor="text-white"
                  linkBorderType="border-b-2"
                  linkBorderColor="border-white"
                  linkIconSize="h-4"
                  linkIconColor="invert"
                  linkIconMargin="ml-5"
                ></GroupsDualTile>
                <div className="relative bg-slate-600 mt-20">
                  <img
                    loading="lazy"
                    src={img_pajaro_groups}
                    className="absolute w-[20rem] right-0 mr-3 bottom-20"
                  ></img>
                </div>
              </div>
            </div>
          ) : (
            <div className="bg-[#82AB40] lg:col-span-2 lg:mb-0 md:mb-10 sm:mb-10 mb-10 lg:mx-0 md:mx-10 sm:mx-10 mx-10">
              <div className="overflow-hidden">
                <GroupsMobileTile
                  ico={ico_pajaro}
                  title={<h1 className="text-3xl font-bold  mt-5">Avifauna</h1>}
                  subTile=""
                  linkPage="/grupos/avifauna"
                  linkSide="right"
                  linkName="Entrar"
                  linkFontsize="text-xl"
                  linkTextColor="text-white"
                  linkBorderType="border-b-2"
                  linkBorderColor="border-white"
                  linkIconSize="h-4"
                  linkIconColor="invert"
                  linkIconMargin="ml-5"
                ></GroupsMobileTile>
                <div className="relative  w-full">
                  <img
                    loading="lazy"
                    src={img_pajaro_groups}
                    className="absolute w-[14rem]  right-0 bottom-0"
                  ></img>
                </div>
              </div>
            </div>
          )}

          <div className="lg:col-span-3 "></div>
        </div>
      </div>

      <SpeciesInfo />
    </div>
  );
};

export default GroupsScreen;
